import styled from '@emotion/styled';

/**
 * Naked icon button — transparent, borderless, hover-dims. For a bordered
 * icon button built on the design system, use `IconsButton` (IconsButton.tsx).
 */
export const PlainIconButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;

    &:hover {
        opacity: 0.8;
    }
`;
